export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS';
export const USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL';

export const ACTIVATE_ACCOUNT_REQUEST = 'ACTIVATE_ACCOUNT_REQUEST';
export const ACTIVATE_ACCOUNT_SUCCESS = 'ACTIVATE_ACCOUNT_SUCCESS';
export const ACTIVATE_ACCOUNT_FAIL = 'ACTIVATE_ACCOUNT_FAIL';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';

export const LIST_USER_REQUEST = 'LIST_USER_REQUEST';
export const LIST_USER_SUCCESS = 'LIST_USER_SUCCESS';
export const LIST_USER_FAIL = 'LIST_USER_FAIL';

export const USER_FORGOT_REQUEST = 'USER_FORGOT_REQUEST';
export const USER_FORGOT_SUCCESS = 'USER_FORGOT_SUCCESS';
export const USER_FORGOT_FAIL = 'USER_FORGOT_FAIL';

export const USER_GOOGLE_REQUEST = 'USER_GOOGLE_REQUEST';
export const USER_GOOGLE_SUCCESS = 'USER_GOOGLE_SUCCESS';
export const USER_GOOGLE_FAIL = 'USER_GOOGLE_FAIL';

export const USER_FACEBOOK_REQUEST = 'USER_FACEBOOK_REQUEST';
export const USER_FACEBOOK_SUCCESS = 'USER_FACEBOOK_SUCCESS';
export const USER_FACEBOOK_FAIL = 'USER_FACEBOOK_FAIL';

export const USER_RESET_REQUEST = 'USER_RESET_REQUEST';
export const USER_RESET_SUCCESS = 'USER_RESET_SUCCESS';
export const USER_RESET_FAIL = 'USER_RESET_FAIL';

export const USER_LOGOUT = 'USER_LOGOUT';